import { render, staticRenderFns } from "./CargoType.vue?vue&type=template&id=805f162c&scoped=true&"
import script from "./CargoType.vue?vue&type=script&lang=js&"
export * from "./CargoType.vue?vue&type=script&lang=js&"
import style0 from "./CargoType.vue?vue&type=style&index=0&id=805f162c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805f162c",
  null
  
)

export default component.exports